import React from 'react';
import { useDemo } from '../../contexts/DemoContext';
import { WelcomeScreen } from '../screens/WelcomeScreen';
import { PrequelEntryScreen } from '../screens/PrequelEntryScreen';
import { PrequelStoryScreen } from '../screens/PrequelStoryScreen';
import { PrequelQuietScreen } from '../screens/PrequelQuietScreen';
import { BridgeScreen } from '../screens/BridgeScreen';
import { ArrivalScreen } from '../screens/ArrivalScreen';
import { CluesScreen } from '../screens/CluesScreen';
import { SortingScreen } from '../screens/SortingScreen';
import { ActionScreen } from '../screens/ActionScreen';
import { PauseScreen } from '../screens/PauseScreen';
import { WitnessScreen } from '../screens/WitnessScreen';
import { RippleScreen } from '../screens/RippleScreen';
import { SignalCheckScreen } from '../screens/SignalCheckScreen';
import { WateringMapScreen } from '../screens/WateringMapScreen';
import { EchoScreen } from '../screens/EchoScreen';
import { FinishScreen } from '../screens/FinishScreen';
import type { ScreenId } from '../../types/demo';
const SCREENS: Record<ScreenId, React.ComponentType> = {
  welcome: WelcomeScreen,
  prequelEntry: PrequelEntryScreen,
  prequelStory: PrequelStoryScreen,
  prequelQuiet: PrequelQuietScreen,
  bridge: BridgeScreen,
  arrival: ArrivalScreen,
  clues: CluesScreen,
  sorting: SortingScreen,
  action: ActionScreen,
  pause: PauseScreen,
  witness: WitnessScreen,
  ripple: RippleScreen,
  signalCheck: SignalCheckScreen,
  wateringMap: WateringMapScreen,
  echo: EchoScreen,
  finish: FinishScreen
};
export function ScreenRouter() {
  const {
    state
  } = useDemo();
  const Screen = SCREENS[state.currentScreen];
  return <Screen key={state.currentScreen} data-id="element-484" data-mp="hnpputpx9vn7" />;
}